import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import type { Params } from "@/services/api/odin/activities/diagnostic/study-session/create"

export default function useCreateDiagnosticStudySession() {
  const mutation = useMutation({
    mutationFn: (params: Params) => {
      return api.odin.activities.diagnostic.studySession.create(params)
    },
  })

  return mutation
}
